import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { generateCodeChallenge } from "../CodeVerifier";

const Callback = () => {
  const navigate = useNavigate();
  const errormsg = "Error in fetching tokens";
  const tokenurl = "";
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const code = query.get("code");

    if (code) {
      fetchTokens(code)
        .then(() => {
          navigate("/home");
        })
        .catch(() => {
          navigate("/");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const fetchTokens = async (code: string) => {
    interface details1 {
      grant_type: string;
      client_id: string;
      code: string;
      redirect_uri: string;
      code_verifier: string;
    }
    const details: details1 = {
      grant_type: "authorization_code",
      client_id: "a323d493-71b3-435e-b5f7-2d21f16383ee",
      code: code,
      redirect_uri: "redirect_uri=one.vocdev.toyota.com",
      code_verifier: generateCodeChallenge(""),
    };

    const formBody = Object.keys(details)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(details[key as keyof details1]))
      .join("&");

    const response = await fetch(tokenurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    });

    const data = await response.json();
    if (data.access_token) {
      localStorage.setItem("accessToken", data.access_token);
      localStorage.setItem("refreshToken", data.refresh_token);
      localStorage.setItem("idToken", data.id_oken);
      setInterval(() => {
        refreshToken(data.refresh_token);
      }, 3000000);
    } else {
      throw new Error(errormsg);
    }
  };

  const refreshToken = async (refreshToken: string) => {
    interface details {
      grant_type: string;
      client_id: string;
      refresh_token: string;
    }
    const details: details = {
      grant_type: "refresh_token",
      client_id: "a323d493-71b3-435e-b5f7-2d21f16383ee",
      refresh_token: refreshToken,
    };

    const formBody = Object.keys(details)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(details[key as keyof details]))
      .join("&");

    const response = await fetch(tokenurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    });

    const data = await response.json();
    if (data.access_token) {
      localStorage.setItem("accessToken", data.access_token);
      localStorage.setItem("refreshToken", data.refresh_token);
      localStorage.setItem("idToken", data.id_token);
    } else {
      throw new Error(errormsg);
    }
  };

  return <div>loading...</div>;
};

export default Callback;
